export const NODE_TYPE_TO_INLINE_DELIMITER_MAP = {
  strong: '**',
  emphasis: '_',
  inlineCode: '`',
  delete: '~',
} as const
export type FormatInlineNodeType = keyof typeof NODE_TYPE_TO_INLINE_DELIMITER_MAP

export const WRAP_DELIMITER_MAP = {
  '*': '*',
  _: '_',
  $: '$',
  '~': '~',
  '[': ']',
  '(': ')',
  '`': '`',
}

export type WrappableDelimiter = keyof typeof WRAP_DELIMITER_MAP
